import { ServiceCode, ArtifactType, UserRequestChannel } from '@/shared/types';

import { IACUserRequestChannel } from '@/modules/iac/types';

import { SERVICE_CODES } from '@/lib/consts';

export const SEDUserRequestChannels: Record<UserRequestChannel, string> = {
  [UserRequestChannel.EKG]: 'Єдине вікно',
  [UserRequestChannel.NPU]: 'Національна поліція України',
  [UserRequestChannel.SGD]: 'Суб’єкт господарювання',
};

export const IACUserRequestChannels: Partial<Record<IACUserRequestChannel, string>> = {
  [IACUserRequestChannel.CNA]: 'ЦНАП',
  [IACUserRequestChannel.VPR]: 'ВПР',
  [IACUserRequestChannel.TSC]: 'ТСЦ',
  [IACUserRequestChannel.MVC]: 'Сайт МВС',
  [IACUserRequestChannel.DII]: 'Портал Дія',
  [IACUserRequestChannel.DMI]: 'Портал Дія',
  [IACUserRequestChannel.DCI]: 'Портал Дія',
  [IACUserRequestChannel.DPI]: 'Портал Дія',
  [IACUserRequestChannel.CIC]: 'Електроний кабінет громадянина',
  [IACUserRequestChannel.EXT]: 'АРМ ІАС',
};

export const ArtifactTypeNameMapping: Record<ArtifactType, string> &
  Partial<Record<`${ArtifactType}.${ServiceCode}`, string>> = {
  [ArtifactType.EXTRACT]: 'Витяг',
  [ArtifactType.RECEIPT]: 'Квитанція',
  [ArtifactType.SIGN]: 'Файл підпису',
  [ArtifactType.MESSAGE]: 'Повідомлення',
  [ArtifactType.APPLICATION]: 'Копія заяви',
  [ArtifactType.INSURANCE]: 'Договір страхування',
  [ArtifactType.BUNDLE]: 'Відповідь',
  [ArtifactType.REFUSAL]: 'Відмова',
  [ArtifactType.RECEIPT_ARCHIVE]: 'Архів квитанцій',
  [`${ArtifactType.APPLICATION}.${SERVICE_CODES.MISSING_PERSON}`]: 'Копія анкети',
  [`${ArtifactType.APPLICATION}.${SERVICE_CODES.CITIZEN_APPEAL_TO_MVS}`]: 'Копія звернення',
  [`${ArtifactType.APPLICATION}.${SERVICE_CODES.MISSING_PERSON_EXTRACT}`]: 'Копія запиту',
};
